import { render, staticRenderFns } from "./LogosItemClickable.vue?vue&type=template&id=6cbb3fa7&scoped=true&"
import script from "./LogosItemClickable.vue?vue&type=script&lang=ts&"
export * from "./LogosItemClickable.vue?vue&type=script&lang=ts&"
import style0 from "./LogosItemClickable.vue?vue&type=style&index=0&id=6cbb3fa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb3fa7",
  null
  
)

export default component.exports